module.exports = "<header class=\"header bg-ui-general d-none d-sm-flex\">\n  <div class=\"header-info\">\n    <h1 class=\"header-title\">\n      <strong>Kalendarz</strong>\n      <small>Zarządzaj swoimi dostępnościami.</small>\n    </h1>\n  </div>\n</header>\n<div class=\"main-content\">\n  <div class=\"card card-body\">\n    <angular2-fullcalendar [options]=\"calendarOptions\"></angular2-fullcalendar>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/calendar/calendar.component.html
// module id = ../../../../../src/app/components/home/calendar/calendar.component.html
// module chunks = main